import ComponentDescription from "components/customs/ComponentDescription";
import ComponentHeader from "components/cms/ComponentHeader";
import { IconListDefinitions } from "./IconListDefinitions";

export class IconList extends IconListDefinitions {
    render() {
        const style = this.props.designing
            ? {
                minHeight: "100px",
                padding: "0px",
            }
            : {
                minHeight: "auto",
                padding: "10px",
            };

        return (
            <div
                data-schema-id={this.props.id}
                className={`fa-draggable fa-IconList ${this.props.designing ? "designing" : ""
                    }`}
                style={{ ...style, position: "relative" }}
            >
                <ComponentHeader
                    componentEntry={this.props.entry}
                    componentSchemaId={this.props.id as string}
                />

                <ComponentDescription
                    node={this.props.schemaNode}
                    entry={this.props.entry}
                />
            </div>
        );
    }
}
